// Datos fijos de la empresa para el membrete de recibos/comprobantes.
export const EMPRESA_NOMBRE = 'Acuarios Cred';
export const EMPRESA_RUC = '10800701835';
export const EMPRESA_DIRECCION = 'Calle Santo Pedro / San Tomas Mz. A Lt. 12, Ucayali - Coronel Portillo - Yarinacocha';
